import React from 'react';

const Features = ({ data, stats }) => {
  // Default config if no data provided
  const config = data || {
    sectionTitle: "Complete MCN Platform Features",
    sectionDescription: "Everything you need to manage creators, content, and revenue at scale",
    features: []
  };

  // Safely access stats with defaults
  const safeStats = stats || { creators: 0, channels: 0 };

  // Helper function to replace placeholders in text
  const replacePlaceholders = (text) => {
    if (!text) return '';
    return text
      .replace('{creators}', safeStats.creators || 0)
      .replace('{channels}', safeStats.channels || 0);
  };

  return (
    <section id="features" className="py-16 lg:py-24 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-2xl mx-auto mb-10">
          <h2 className="text-3xl font-extrabold">{config.sectionTitle}</h2>
          <p className="mt-2 text-slate-600">{config.sectionDescription}</p>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {config.features.map((feature, index) => (
            <div 
              key={index}
              className="p-6 rounded-2xl border border-slate-200 bg-white shadow-sm hover:shadow-md transition-all"
            >
              {/* Icon */}
              <div 
                className={`w-12 h-12 rounded-xl bg-${feature.iconColor}-100 flex items-center justify-center mb-4`}
              >
                <svg 
                  className={`w-6 h-6 text-${feature.iconColor}-600`} 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                  dangerouslySetInnerHTML={{ __html: feature.iconPath }}
                />
              </div>

              {/* Title */}
              <h3 className="font-semibold">{feature.title}</h3>

              {/* Description with placeholder replacement */}
              <p className="mt-1 text-sm text-slate-600">
                {replacePlaceholders(feature.description)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;